import { LoanProductCategory } from '@mediaingenuity/totallymoney.types'

import { categories } from '@config/categories'

export const getCategoryIdForPath = (
    categoryPath: string
): LoanProductCategory => {
    let categoryId: LoanProductCategory = 'Personal'

    for (const [key, value] of Object.entries(categories)) {
        if (categoryPath == value?.path) {
            categoryId = key as LoanProductCategory
            break
        }
    }

    return categoryId
}
